export const facilities = [
  {
    slug: 'galenia-hospital-cancun',
    name: 'Galenia Hospital',
    country: 'Mexico',
    city: 'Cancun',
    totalBeds: '55',
    keySpecialties: ['Orthopedics', 'Cosmetic Surgery', 'General Surgery'],
    freeOnlineConsultation: true,
    accreditations: ['JCI', 'CSG'],
    description:
      'Galenia Hospital is a state-of-the-art medical facility located in the heart of Cancun. It is the only hospital in Mexico to hold three major accreditations: JCI, Accreditation Canada International, and the General Health Council of Mexico. It offers world-class care in a resort-like setting.',
    image:
      'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=2906&auto=format&fit=crop',
  },
  {
    slug: 'hospital-angeles-tijuana',
    name: 'Hospital Angeles',
    country: 'Mexico',
    city: 'Tijuana',
    totalBeds: '120',
    keySpecialties: ['Bariatric Surgery', 'Cardiology', 'Oncology'],
    freeOnlineConsultation: false,
    accreditations: ['CSG'],
    description:
      'Part of the largest private hospital network in Mexico, Hospital Angeles Tijuana provides highly specialized medical care just minutes from the US border. It is renowned for its bariatric and cardiology programs.',
    image:
      'https://images.unsplash.com/photo-1586773860418-d37222d8fce3?q=80&w=2946&auto=format&fit=crop',
  },
  {
    slug: 'sani-dental-group-los-algodones',
    name: 'Sani Dental Group',
    country: 'Mexico',
    city: 'Los Algodones',
    totalBeds: 'Outpatient Clinic',
    keySpecialties: ['Dental Implants', 'Full Mouth Restoration'],
    freeOnlineConsultation: true,
    accreditations: ['ADA Affiliated'],
    description:
      'Located in the "Dental Capital of the World," Sani Dental Group is one of the largest and most prestigious dental clinics in Mexico, offering comprehensive dental restorations at a fraction of US prices.',
    image:
      'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?q=80&w=2874&auto=format&fit=crop',
  },
  {
    slug: 'bumrungrad-international-hospital',
    name: 'Bumrungrad International Hospital',
    country: 'Thailand',
    city: 'Bangkok',
    totalBeds: '580',
    keySpecialties: ['Cardiology', 'Orthopedics', 'Health Screening'],
    freeOnlineConsultation: true,
    accreditations: ['JCI'],
    description:
      'One of the largest private hospitals in Southeast Asia, Bumrungrad serves over 1.1 million patients annually, including over 520,000 international patients. It resembles a luxury hotel and offers cutting-edge medical technology.',
    image:
      'https://images.unsplash.com/photo-1538108149393-fbbd81895907?q=80&w=3000&auto=format&fit=crop',
  },
  {
    slug: 'samitivej-sukhumvit-hospital',
    name: 'Samitivej Sukhumvit Hospital',
    country: 'Thailand',
    city: 'Bangkok',
    totalBeds: '275',
    keySpecialties: ['Pediatrics', 'Cosmetic Surgery', 'Gastroenterology'],
    freeOnlineConsultation: true,
    accreditations: ['JCI'],
    description:
      'An award-winning facility known for its exceptional pediatric care and comprehensive cosmetic surgery center. It provides a highly personalized, patient-centric experience.',
    image:
      'https://images.unsplash.com/photo-1512678080530-7760d81faba6?q=80&w=2948&auto=format&fit=crop',
  },
  {
    slug: 'acibadem-healthcare-group',
    name: 'Acibadem Healthcare Group',
    country: 'Turkey',
    city: 'Istanbul',
    totalBeds: '2000+',
    keySpecialties: ['Oncology', 'Neurosurgery', 'Cosmetic Surgery'],
    freeOnlineConsultation: true,
    accreditations: ['JCI'],
    description:
      'A massive network of premium hospitals across Turkey. Acibadem is globally recognized for its advanced oncology centers and complex neurosurgical capabilities.',
    image:
      'https://images.unsplash.com/photo-1504439468489-c8920d786a2b?q=80&w=2942&auto=format&fit=crop',
  },
  {
    slug: 'memorial-sisli-hospital',
    name: 'Memorial Şişli Hospital',
    country: 'Turkey',
    city: 'Istanbul',
    totalBeds: '200',
    keySpecialties: ['IVF', 'Organ Transplant', 'Genetics'],
    freeOnlineConsultation: true,
    accreditations: ['JCI'],
    description:
      'The first JCI-accredited hospital in Turkey, Memorial Şişli is a pioneer in IVF treatments and complex organ transplantations with exceptionally high success rates.',
    image:
      'https://images.unsplash.com/photo-1516549655169-df83a0774514?q=80&w=2940&auto=format&fit=crop',
  },
  {
    slug: 'apollo-hospitals-chennai',
    name: 'Apollo Hospitals',
    country: 'India',
    city: 'Chennai',
    totalBeds: '560',
    keySpecialties: ['Cardiac Surgery', 'Orthopedics', 'Transplants'],
    freeOnlineConsultation: true,
    accreditations: ['JCI', 'NABH'],
    description:
      'The flagship hospital of the Apollo group, it is a global destination for complex cardiac surgeries and multi-organ transplants, offering world-class clinical outcomes.',
    image:
      'https://images.unsplash.com/photo-1587351021759-3e566b6af7cc?q=80&w=2944&auto=format&fit=crop',
  },
  {
    slug: 'fortis-memorial-research-institute',
    name: 'Fortis Memorial Research Institute',
    country: 'India',
    city: 'Gurgaon',
    totalBeds: '314',
    keySpecialties: ['Oncology', 'Neurology', 'Robotic Surgery'],
    freeOnlineConsultation: true,
    accreditations: ['JCI', 'NABH'],
    description:
      'Dubbed the "Mecca of Healthcare," FMRI is a multi-super specialty, quaternary care hospital with an enviable international faculty and cutting-edge technology.',
    image:
      'https://images.unsplash.com/photo-1519494080410-f9aa76cb4283?q=80&w=2948&auto=format&fit=crop',
  },
  {
    slug: 'hospital-cima-san-jose',
    name: 'Hospital CIMA',
    country: 'Costa Rica',
    city: 'San José',
    totalBeds: '100',
    keySpecialties: ['General Surgery', 'Orthopedics', 'Preventative Medicine'],
    freeOnlineConsultation: false,
    accreditations: ['JCI'],
    description:
      'Located in the upscale Escazú suburb, Hospital CIMA is the premier private hospital in Costa Rica, heavily favored by North American expats and medical tourists for its high standards and English-speaking staff.',
    image:
      'https://images.unsplash.com/photo-1512678080530-7760d81faba6?q=80&w=2948&auto=format&fit=crop',
  },
  {
    slug: 'quironsalud-madrid',
    name: 'Quirónsalud Madrid',
    country: 'Spain',
    city: 'Madrid',
    totalBeds: '200',
    keySpecialties: ['Orthopedics', 'Neurology', 'Oncology'],
    freeOnlineConsultation: true,
    accreditations: ['JCI'],
    description:
      "Part of Spain's leading private hospital group, offering cutting-edge medical technology and highly personalized care in a luxurious environment.",
    image:
      'https://images.unsplash.com/photo-1538108149393-fbbd81895907?q=80&w=3000&auto=format&fit=crop',
  },
  {
    slug: 'kreativ-dental-clinic',
    name: 'Kreativ Dental Clinic',
    country: 'Hungary',
    city: 'Budapest',
    totalBeds: 'Outpatient Clinic',
    keySpecialties: ['Implantology', 'Cosmetic Dentistry'],
    freeOnlineConsultation: true,
    accreditations: ['ISO 9001'],
    description:
      'A world-renowned dental clinic in Budapest, offering extensive dental restorations and cosmetic dentistry with an on-site, state-of-the-art dental laboratory.',
    image:
      'https://images.unsplash.com/photo-1606811841689-23dfddce3e95?q=80&w=2874&auto=format&fit=crop',
  },
  {
    slug: 'mediclinic-city-hospital',
    name: 'Mediclinic City Hospital',
    country: 'United Arab Emirates',
    city: 'Dubai',
    totalBeds: '280',
    keySpecialties: ['Oncology', 'Cardiology', 'Terminal Care'],
    freeOnlineConsultation: true,
    accreditations: ['JCI'],
    description:
      'Located in Dubai Healthcare City, this ultra-modern facility provides premium, multi-disciplinary care, catering heavily to high-net-worth individuals and expats.',
    image:
      'https://images.unsplash.com/photo-1504439468489-c8920d786a2b?q=80&w=2942&auto=format&fit=crop',
  },
]
